<template>
  <nav>
    <aside class="menu app-sidebar" :class="active">
      <div class="brand">
        <brand-link/>
        <section class="is-flex align-center">
          <notification-panel/>
          <user-dropdown/>
        </section>
      </div>
      <div class="items sidebar-content pt-1">
        <ul class="menu-list">
          <nav-route exact name="home" icon="grid">Workflow</nav-route>
          <nav-route exact name="my-notes" icon="pen-tool">Notes</nav-route>
        </ul>

        <ul class="menu-list">
          <nav-route name="project-index" icon="clipboard">Projects</nav-route>
          <nav-route name="label-index" icon="tag">Labels</nav-route>
        </ul>

        <ul class="menu-list">
          <nav-route name="connection-index" icon="link">Companies</nav-route>
          <nav-route name="connection-requests-incoming" icon="refresh-cw" :badge="pendingRequestsCount">Requests</nav-route>
        </ul>

        <div class="spacer"/>

        <ul class="menu-list">
          <nav-route exact name="account-manager" icon-pack="zondicons" icon="store-front">Account</nav-route>
        </ul>
      </div>
    </aside>
  </nav>
</template>

<script>
import { mapState } from 'vuex'

export default {

  components: {
    BrandLink: () => import('./partials/BrandLink'),
    UserDropdown: () => import('./partials/UserDropdown'),
    NotificationPanel: () => import('./partials/NotificationPanel'),
  },

  props: ['active'],

  created() {
    this.countConnectionRequests()
  },

  methods: {
    countConnectionRequests() {
      this.$store.dispatch('connectionRequest/countRequests')
    }
  },

  computed: {
    ...mapState('connectionRequest', {
      pendingRequestsCount: 'count'
    })
  }
}
</script>
